import { FC, useEffect, useState } from 'react';
import { textures } from '../../../../textures';
import { randMember } from '../../../../utils';

export type TextureNFTProps = {};
export const TextureNFT: FC<TextureNFTProps> = () => {
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const texture = randMember(Object.keys(textures));
    const gt = textures[texture]();
    gt.canvas.style.imageRendering = 'pixelated';
    gt.canvas.style.position = 'absolute';
    gt.canvas.style.left = '50%';
    gt.canvas.style.top = '50%';
    gt.canvas.style.transform = 'translate(-50%,-50%)';

    const onClick = () => {
      setVersion(version + 1);
    };
    const onResize = () => {
      const aspect = gt.canvas.width / gt.canvas.height;
      const windowAspect = window.innerWidth / window.innerHeight;
      if (aspect > windowAspect) {
        gt.canvas.style.width = '100%';
        gt.canvas.style.height = 'auto';
      } else {
        gt.canvas.style.width = 'auto';
        gt.canvas.style.height = '100%';
      }
    };
    onResize();
    document.body.addEventListener('click', onClick);
    window.addEventListener('resize', onResize);

    document.body.appendChild(gt.canvas);

    let alive = true;
    let last = Date.now();
    const step = () => {
      const now = Date.now();
      const delta = (now - last) / 1000;
      last = now;
      gt.step(delta);
      if (alive) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
    return () => {
      alive = false;
      document.body.removeChild(gt.canvas);
      document.body.removeEventListener('click', onClick);
      window.removeEventListener('resize', onResize);
    };
  }, [version]);

  return null;
};
